/*
Author : Arman Ali
Module: Shared State
github: https://github.com/Arman-Arzoo
*/

import { createAsyncThunk } from '@reduxjs/toolkit';
import apiInstance from '../../Apis/Axios';
import { IMAGE_SERVICE } from '../EndPoints';
import axios from 'axios';
import { URL } from '../../Apis/Constants';

// List all the Employee
export const UploadImage = createAsyncThunk('sharedSlice/uploadImage', async (params, { dispatch, getState }) => {
    const result = await apiInstance
        .put(IMAGE_SERVICE.uploadImage, params)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;
    return { data, status };
});

export const PublicUploadImage = createAsyncThunk(
    'sharedSlice/publicUploadImage', async (params, { dispatch, getState, rejectWithValue }) => {
        try {
            const response = await axios.put(`${URL}${IMAGE_SERVICE.publicUploadImage}`, params);
            return response.data;
        } catch (error) {
            console.error("Upload error", error);
            return rejectWithValue(error.response?.data || "Upload failed");
        }
    }
);
